module.exports = __webpack_public_path__ + "94f82180375eb774be60ec85e684be7e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/16_D#3.mp3
// module id = 56
// module chunks = 0